{
  "names": {
    "Fajr": "İmsak",
    "Dhuhr": "Öğle",
    "Asr": "İkindi",
    "Maghrib": "Akşam",
    "Isha": "Yatsı"
  },
  "card": {
    "label": "Sonraki namaz",
    "labelTomorrow": "Yarın · {{prayer}}",
    "inHoursMinutes": "{{hours}} sa {{minutes}} dk içinde",
    "inMinutes": "{{minutes}} dk içinde",
    "open_aria": "Namaz vakitlerini aç",
    "pro": "Rhemn Pro",
    "unlock_aria": "Namaz vakitlerini Rhemn Pro ile aç",
    "unavailable": "Namaz vakitleri şu anda kullanılamıyor."
  },
  "sheet": {
    "bellOn_aria": "{{prayer}} hatırlatıcısını kapat",
    "bellOff_aria": "{{prayer}} hatırlatıcısını aç",
    "explainer": "Her namazda nazik bir hatırlatma alın. Hatırlatmalar sessiz bildirimlerdir — varsayılan olarak ses yok.",
    "enableReminders": "Hatırlatıcıları etkinleştir",
    "enableInSettings": "Namaz hatırlatıcıları almak için Ayarlar’da Rhemn bildirimlerini açın.",
    "openSettings": "Ayarları aç"
  },
  "notifications": {
    "body": "Namaz vakti geldi."
  },
  "focus": {
    "label": "{{prayer}} Namazı",
    "close_aria": "Namaz ekranını kapat",
    "hint": "Dönmek için Esc veya × tuşuna basın",
    "phrases": {
      "accepted": "Allah namazınızı kabul etsin",
      "acceptedAr": "تقبّل الله صلاتك"
    }
  },
  "ambient": {
    "default": "Niyetle başla. Bereketle devam et.",
    "prayerApproaches": "Bir sonraki namaz vaktiniz yaklaşıyor. Niyetinize bağlı kalın.",
    "morningPursue": "Şunu hedeflemek için mübarek bir sabah: {{focus}}",
    "dayCloses": "Gün biterken şunun üzerine düşünün: {{focus}}",
    "fulfilled": "Bugün niyetinizi gerçekleştirdiniz. Elhamdülillah.",
    "workingTowards": "Bugün şuna doğru çalışıyorsunuz: {{focus}}",
    "prayerNear": "Bir sonraki namaz vaktiniz yakın. Bir nefes alın."
  },
  "widget": {
    "countdown": "{{time}} içinde",
    "openToUpdate": "Güncellemek için Rhemn'i aç",
    "openForVerse": "Günün ayeti için Rhemn'i aç"
  }
}
